// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationValidationScore_container__fa2fN"};